import React, { useEffect } from "react";
import { SearchIcon } from "@heroicons/react/solid";
import { ThreeDots } from "react-loading-icons";
import useState from "react-usestateref";
import axios from "axios";

import backendService from "../services.js/backendService";
import { XIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function SearchMessageModal({ ShowSearchMessageModal, userInfo }) {
  const [searchMessage, setSearchMessage, searchMessageRef] = useState("");
  const [searchMessageList, setSearchMessageList, searchMessageListRef] =
    useState([]);
  const [searchMessageListLoading, setSearchMessageListLoading] =
    useState(false);

  const searchInMessage = async () => {
    setSearchMessageListLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/searchmessages/${userInfo._id}/${searchMessageRef.current}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setSearchMessageList(res.data);
      setSearchMessageListLoading(false);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(async () => {
    if (searchMessage.length > 0) {
      await searchInMessage();
    }
  }, [searchMessage]);

  return (
    <>
      <div className="justify-center items-center flex  fixed inset-0 z-50 outline-none focus:outline-none   ">
        <div className="w-11/12 sm:w-5/6 md:w-2/3 lg:w-1/2 relative my-6 shadow-md shadow-black mx-auto max-w-2xl rounded-md bg-palette_color2">
          {/*content*/}
          <div className="border-0 rounded-lg  relative flex-col  w-full  outline-none focus:outline-none">
            {/*header*/}
            <div className="flex justify-end bg-palette_color2 pt-2 pr-2">
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 text-primary"
                  aria-hidden="true"
                  onClick={() => ShowSearchMessageModal(false)}
                />
              </div>
            </div>
            <div className="flex   bg-palette_color2 mx-6">
              <div className="flex  w-[7%] bg-background justify-evenly items-center  rounded-t">
                {!searchMessageListLoading ? (
                  <SearchIcon
                    className=" h-6 w-6 text-palette_color1 mr-3"
                    aria-hidden="true"
                  />
                ) : (
                  <ThreeDots
                    className="h-6 w-6 text-palette_color1"
                    fill="#764deb"
                  />
                )}

                {/* <ThreeDots
                className=" h-6 w-6  text-menu_background  cursor-pointer "
                fill="#525252"
              /> */}
              </div>
              <div className="w-[92%]">
                <input
                  type="text"
                  name="search"
                  id="search"
                  autoComplete="off"
                  className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                  placeholder=" Search"
                  onChange={(e) => setSearchMessage(e.target.value)}
                />
              </div>
            </div>
            {/*body*/}
            <div className=" flex-col justify-center text-primary text-xl items-center p-6 flex-auto bg-palette_color2 rounded-b ">
              <div className="max-h-[60vh] overflow-y-auto overflow-x-hidden scroll-smooth row_Overflow ">
                {searchMessageRef.current.length === 0 ? (
                  <div className="text-center text-xl text-primary font-robo ">
                    <p>Enter text to search</p>
                  </div>
                ) : searchMessageListRef.current.length > 0 &&
                  searchMessageRef.current.length > 0 ? (
                  searchMessageList.map((message) =>
                    MessageCard({
                      message: message.content,
                      senderID: message.senderId,
                      time: message.createdAt,
                    })
                  )
                ) : (
                  <div className="text-center text-xl text-primary font-robo ">
                    No Messages Found
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-50  fixed inset-0 z-40 bg-black"></div>
    </>
  );

  function MessageCard({ senderID, message, time }) {
    return (
      <div className="w-full ">
        <div className="w-full py-3  grid grid-rows-2 grid-flow-row auto-cols-max   gap-0 ">
          <div className="col-span-2 ">
            <h3 className="text-sm font-robo  text-primary">
              {
                //format time and data here
                new Date(time).toLocaleString()
              }
            </h3>
          </div>
          <div className="flex items-center ">
            <h3 className="text-lg font-robo text-palette_color1 ">
              {senderID !== userInfo.participants[0]._id
                ? "You:"
                : userInfo.participants[0].username + ":"}
            </h3>

            {/*  important div dont remove */}

            {/*  important div dont remove */}
            <div className="ml-1  w-[80%]">
              <h3 className="text-base font-robo text-primary truncate ">
                {message}
              </h3>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchMessageModal;
